import { useHistory, useLocation } from 'react-router-dom'

import InlineDropdown from 'components/InlineDropdown'
import { filterOptions } from 'consts'
import { useTranslate } from 'lib/tolgee'
import { analyticsTracker } from 'utils'

import './index.scss'

const FILTER_NAME = 'sortBy'
const SORT_BY_OPTIONS = filterOptions.videosSortBy

const SortByFilterV2 = ({
  pageName = '',
  disabled = false,
  options = SORT_BY_OPTIONS,
  defaultValue = 'likes',
  additionalTracking,
}) => {
  const location = useLocation()
  const history = useHistory()
  const t = useTranslate()

  const searchParams = new URLSearchParams(location.search)
  const searchParamsIn = searchParams.getAll(FILTER_NAME)

  const handleFilterChange = value => {
    if (value.key === defaultValue) {
      searchParams.delete(FILTER_NAME)
      history.push({ search: searchParams.toString() })
      return
    }
    searchParams.set(FILTER_NAME, [value.key])
    history.push({ search: searchParams.toString() })

    additionalTracking?.(value?.label)

    const { FILTER } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(FILTER, {
      Filter: 'sortBy',
      'Filter label': value?.label,
      Page: pageName,
    })
  }

  const selectedOption = options.find(option => option.key === searchParamsIn[0]) ?? options[0]

  return (
    <div className="SortByFilterV2">
      <InlineDropdown
        label={t({ key: `VideoFilterComponent-sortByFilter`, defaultValue: 'Sort by' })}
        options={options}
        selected={selectedOption}
        onChange={value => handleFilterChange(value)}
        disabled={disabled}
      />
    </div>
  )
}

export default SortByFilterV2
